/** @format */

import React from 'react'

import Button from '@src/components/tailwind/Button'
import LoaderButton from '@src/components/tailwind/LoaderButton'
import {useModalContext} from '@src/components/tailwind/ModalContext'
import * as Modal from '@src/components/tailwind/ModalV2'

import {useLoadingContext} from '@src/contexts'
import * as toast from '@src/toast'

import {FieldValidation} from './FieldValidation'
import {useValidationApi} from './ValidationApi'

type DeleteFieldModalProps = {
  modal: string
  validation: FieldValidation
}

export function DeleteFieldModal(props: DeleteFieldModalProps) {
  const {modal, validation} = props
  const {fieldName} = validation
  const {isOpen, closeCurrentModal} = useModalContext()

  const {ready} = useLoadingContext()
  const api = useValidationApi()
  async function handleDeleteButtonClick(): Promise<void> {
    try {
      await api.delete(fieldName)
      closeCurrentModal()
    } catch (err) {
      toast.error(err)
    } finally {
      ready()
    }
  }

  return (
    <Modal.Root isOpen={isOpen(modal)} onClose={closeCurrentModal}>
      <Modal.DefaultLayout>
        <Modal.Header title="Delete validation" />
        <Modal.Content>
          <Modal.Description>
            Validation for field{' '}
            <code className="rounded bg-gray-100 px-2 text-sm font-semibold">
              {fieldName}
            </code>{' '}
            will be deleted.
          </Modal.Description>
        </Modal.Content>
        <Modal.Footer>
          <div className="flex justify-end gap-2">
            <Button onClick={closeCurrentModal}>Cancel</Button>
            <LoaderButton onClick={handleDeleteButtonClick}>
              Delete
            </LoaderButton>
          </div>
        </Modal.Footer>
      </Modal.DefaultLayout>
    </Modal.Root>
  )
}
